import TheAutoReserveModal from '@components/ui/hotelPage&view/TheAutoReserveModal/TheAutoReserveModal.vue';
import TheOldAutoReserveModal from '@components/ui/hotelPage&view/TheOldAutoReserveModal.vue';

const useAutoReserveModal = () => {
    const autoReserveStore = useAutoReserveStore();
    const openAutoReserveModal = async (eventName: string) => {
        const analyticsStore = useAnalyticsStore();
        const authStore = useAuthStore();
        analyticsStore.trackAll('autoreserve_view_modal', {
            ...analyticsStore.tripEventMetric,
            ...authStore.eventMetrics,
            eventName,
            autoReserveVersion: autoReserveStore.oldFlowEnabled ? 1 : 2,
            ...autoReserveStore.eventMetric,
        });
        const { open } = useModal({
            component: autoReserveStore.oldFlowEnabled
                ? TheOldAutoReserveModal
                : TheAutoReserveModal,
            modalAttrs: {
                zIndexFn: () => 100000000,
            },
        });
        const val = await open();
        if (!val.args?.[0]?.silentClose) {
            autoReserveStore.resetAutoReserve(true);
        }
    };
    return {
        openAutoReserveModal,
    };
};

export default useAutoReserveModal;
